<template>
    <div class="page-api">

        <section class="section-shaped my-0">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="container shape-container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3 text-white">Interaction API</h2>
                        <p class="lead text-white">A developed system of multidirectional interaction with all participants in an insurance process</p>
                        <div class="btn-wrapper">
                            <router-link to="/contacts" class="btn btn-neutral text-warning">Contact us</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">Brief technical description</h2>
                        <p>The API is organized around <a href="https://en.wikipedia.org/wiki/Representational_state_transfer" target="_blank">REST</a>. Our API has predictable resource-oriented URLs and uses HTTP response codes to indicate API request failures.</p>
                        <p>We use built-in HTTP features such as HTTP authentication and HTTP commands that are understood by standard HTTP clients.</p>
                        <p>We support <a href="https://en.wikipedia.org/wiki/Cross-origin_resource_sharing" target="_blank">cross-origin resource sharing</a>, which allows you to securely interact with our API from a client web application (although you should never expose the API secret key in client-side code on a public website).</p>
                        <p>The response from the API will be <a href="http://www.json.org/" target="_blank">JSON</a>, including errors, although our API libraries will convert responses to the appropriate language-specific objects.</p>

                        <div>
                            <badge type="warning" rounded>REST</badge>
                            <badge type="warning" rounded>CORS</badge>
                            <badge type="warning" rounded>JSON</badge>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
export default {};
</script>
<style>
</style>
